import React from 'react';
export function PainPoints() {
  const limitingBeliefs = ['No tengo tiempo suficiente', 'No tengo experiencia', 'No sé por dónde empezar', 'Me da vergüenza ofrecer algo', 'No sé usar herramientas digitales'];
  return <section className="pt-8 pb-6 px-5" style={{
    background: 'linear-gradient(to bottom, #FDE6EC 0%, #FFFFFF 100%)'
  }} data-id="element-149">
      <div className="max-w-md mx-auto text-center" data-id="element-150">
        {/* Opening Headline */}
        <h2 className="text-xl font-bold text-[#222222] leading-tight" data-id="element-151">
          Si alguna vez pensaste:{' '}
          <span className="text-[#FF4DA6]" data-id="element-152">"No se me da vender"</span>...
        </h2>

        {/* Italic Subline */}
        <p className="text-base text-[#666666] italic mt-2" data-id="element-153">
          Lo que te falta no es talento… es el camino claro.
        </p>

        {/* Intro Paragraph */}
        <p className="text-sm text-[#444444] mt-3 leading-relaxed max-w-[85%] mx-auto" data-id="element-154">
          Hay mujeres que quieren aportar desde casa, pagar cuentas, salir del
          estrés económico… pero sienten que algo las frena.
        </p>

        {/* Card with Limiting Beliefs */}
        <div className="bg-white rounded-xl shadow-md p-5 mt-5" data-id="element-155">
          <p className="font-bold text-[#222222] text-base mb-4" data-id="element-156">
            ¿Te sientes bloqueada por frases como…?
          </p>

          <div className="space-y-3 text-left" data-id="element-157">
            {limitingBeliefs.map((belief, index) => <div key={index} className="flex items-start gap-3" data-id="element-158">
                <span className="text-red-500 flex-shrink-0" data-id="element-159">❌</span>
                <span className="text-sm text-[#444444]" data-id="element-160">{belief}</span>
              </div>)}
          </div>
        </div>

        {/* Reflection Line */}
        <p className="text-sm text-[#888888] italic mt-5" data-id="element-161">
          Y mientras tanto... el calendario vuelve a empezar con las mismas
          dudas.
        </p>

        {/* Final Insight Line */}
        <p className="text-base font-semibold text-[#FF4DA6] mt-3" data-id="element-162">
          La verdad: no necesitas más habilidades. Solo una estrategia sencilla.
        </p>
      </div>
    </section>;
}